import { http, HttpResponse } from 'msw'

import type { CreateChainAgencyUploadContractParams } from '../../agency/create-chain-agency-upload-contract'

interface CreateChainAgencyUploadContractPathParams {
  alphaId: string
}

export const mockCreateChainAgencyUploadContract = http.post<
  CreateChainAgencyUploadContractPathParams,
  CreateChainAgencyUploadContractParams
>(
  '/my-business/api/agency/v1/agency-chains/:alphaId/contract-data',
  async () => {
    return HttpResponse.json(
      { preSignedUrl: '/api/agency/v1/agency-chains/upload-contract' },
      { status: 200 },
    )
  },
)
